// Unpublished Work © 2023 Deere & Company

import t from 'tcomb';
export const AdminActivities = t.struct({
    canMaintain: t.Boolean,
    canMaintainSecure: t.Boolean,
    canMerge: t.Boolean,
    canView: t.Boolean,
    canViewSecure: t.Boolean
},
{
    defaultProps: {
        canMaintain: false,
        canMaintainSecure: false,
        canMerge: false,
        canView: false,
        canViewSecure: false
    }
});
